// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"CommonCard_r-mobile__wJkvB","r-not-mobile":"CommonCard_r-not-mobile__oiItn","card":"CommonCard_card__n2vZw","card--no-border":"CommonCard_card--no-border__PKMEv"};